export default "__VITE_PUBLIC_ASSET__63c9c506__"